import { Box, Card, Stack, Typography, styled, useTheme } from '@mui/material'
import React from 'react'
import CountWithIconBox from 'src/components/common/CountWithIconBox'
import { IStorage } from 'src/generated-types/storage-types'
import { MUIThemeColors } from 'src/mui-theme'
import { Flex } from 'src/styles/flexComponent'
import { GetRGBA, getThemeColor } from 'src/utils'
import { HomeRepairServiceOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

interface StorageCardProps {
  storage: IStorage
  className?: string
  onClick: (e) => void
  active?: boolean
}

const StorageCard: React.FC<StorageCardProps> = ({ storage, className, onClick, active }) => {
  const theme = useTheme()
  const { t } = useTranslation(['common'])
  return (
    <Box
      onClick={onClick}
      className={className}
      width={'100%'}
      position={'relative'}
      onMouseLeave={e => {
        e.preventDefault()
      }}
    >
      <StorageHeaderCard
        style={{
          height: active ? '100px' : '44px',
          backgroundColor: getThemeColor(theme, MUIThemeColors.secondaryLight),
        }}
        sx={{ backgroundImage: `url(${storage.image?.url ?? '/images/emptyStatus.png'})` }}
      >
        <Box flex={1} paddingTop={active ? '8px' : '3px'}>
          <Stack
            direction={'column'}
            className="pl-12-core pt-2-core pr-6-core pb-2-core"
            alignItems={'flex-start'}
            justifyContent={'center'}
            sx={{
              backgroundColor: getThemeColor(theme, MUIThemeColors.primaryMain),
              width: 'fit-content',
              height: '37px',
              borderRadius: '2px',
            }}
          >
            <Name
              variant="body1"
              fontWeight={200}
              lineHeight={'18px'}
              color={getThemeColor(theme, MUIThemeColors.white)}
            >
              {storage.name}
            </Name>
            {active && (
              <>
                <Typography
                  fontWeight={400}
                  lineHeight={'12px'}
                  variant="caption"
                  color={getThemeColor(theme, MUIThemeColors.white)}
                >
                  {storage?.address}
                </Typography>
              </>
            )}
          </Stack>
        </Box>
        <Flex.Column justifyContent={'flex-end'} className="pl-12-core pb-8-core">
          {active && (
            <Flex.Row flex={1} gap={'2px'}>
              <CountWithIconBox
                title={t('equipment', { ns: 'common' })}
                Component={HomeRepairServiceOutlined}
                value={storage.equipmentCount ?? 0}
                iconBgColor={theme.palette.white[theme.palette.mode]}
                color={theme.palette.white[theme.palette.mode]}
                bgColor={theme.palette.primaryMain[theme.palette.mode]}
                sx={{ fontSize: '14px' }}
              />
            </Flex.Row>
          )}
        </Flex.Column>
      </StorageHeaderCard>
    </Box>
  )
}

export default StorageCard

//styled components

const Name = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 'auto',
  display: 'inline-block',
  fontWeight: 600,
}))

const StorageHeaderCard = styled(Card)(({ theme }) => ({
  '&.MuiPaper-root': {
    backgroundColor: theme.palette.white[theme.palette.mode],
    color: theme.palette.primaryDark[theme.palette.mode],
    boxShadow: `0px 0px 6px ${GetRGBA(theme.palette.black[theme.palette.mode], 0.29)}`,
  },
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  cursor: 'pointer',
  color: theme.palette.white[theme.palette.mode],
}))
